/**
 * Structure utilities for switchboard canvas
 */
import type {
  SwitchboardEdge,
  SwitchboardNode,
} from '../../converters/shared/reactFlowTypes'

/**
 * Get structural signature from nodes and edges
 * Used to detect structural changes (not data changes)
 * Includes handle-level connection details to detect when handles change
 */
export function getStructureSignature(
  nodes: SwitchboardNode[],
  edges: SwitchboardEdge[],
): string {
  const nodeStructure = nodes
    .map((n) => `${n.id}:${n.type}:${n.position.x},${n.position.y}`)
    .sort()
    .join('|')
  const edgeStructure = edges
    .map(
      (e) =>
        `${e.id}:${e.source}->${e.target}:${e.sourceHandle || ''}:${e.targetHandle || ''}`,
    )
    .sort()
    .join('|')
  return `${nodeStructure}||${edgeStructure}`
}
